import { useTranslate } from '@growtherapy/i18n';
import { Button } from '@growtherapy/sprout-ui';

export enum NoAccessVariant {
  Camera = 'camera',
  Microphone = 'microphone',
}

export function NoAccessButton({ onClick }: { onClick: () => void }) {
  const t = useTranslate();
  return (
    <Button use='link' onClick={onClick} className='px-0 text-neutral-800'>
      {t('telehealth-core:controls.learnHowToAllowAccess')}
    </Button>
  );
}
